__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "intencao-registro-preco-mf";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("axios", "0.27.2", function() { return Promise.all([__webpack_require__.e(514), __webpack_require__.e(788), __webpack_require__.e(997)]).then(function() { return function() { return __webpack_require__(788); }; }); });
			register("vee-validate", "2.2.15", function() { return Promise.all([__webpack_require__.e(514), __webpack_require__.e(482), __webpack_require__.e(880)]).then(function() { return function() { return __webpack_require__(482); }; }); });
			register("vue", "2.6.14", function() { return Promise.all([__webpack_require__.e(514), __webpack_require__.e(848), __webpack_require__.e(662)]).then(function() { return function() { return __webpack_require__(6848); }; }); });
			register("vuex", "3.6.2", function() { return Promise.all([__webpack_require__.e(514), __webpack_require__.e(137)]).then(function() { return function() { return __webpack_require__(3518); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};